import { createReducer } from '@reduxjs/toolkit'
import { createSelector } from 'reselect'

import {
  getQuiz,
  addQuiz,
  editQuiz,
  getQuizzes,
  resetQuiz,
  resetAddQuizSuccess,
  resetEditQuizSuccess,
} from './quiz.actions'

const initialState = {
  quizzes: [],
  quizzesTotal: 0,
  quizzesPageSize: 0,
  quizzesPage: 0,

  quiz: null,

  loading: {
    getQuizzes: false,
    getQuiz: false,
    addQuiz: false,
    editQuiz: false,
  },
  error: {
    getQuizzes: false,
    getQuiz: false,
    addQuiz: null,
    editQuiz: null,
  },
  success: {
    addQuiz: false,
    editQuiz: false,
  },
}

const quizReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getQuizzes.fulfilled, (state, action) => {
      state.quizzes = action.payload.results
      state.quizzesTotal = action.payload.total
      state.quizzesPageSize = action.payload.page_size
      state.quizzesPage = action.payload.page

      state.loading.getQuizzes = false
      state.error.getQuizzes = false
    })
    .addCase(getQuizzes.pending, (state) => {
      state.loading.getQuizzes = true
      state.error.getQuizzes = false
    })
    .addCase(getQuizzes.rejected, (state) => {
      state.loading.getQuizzes = false
      state.error.getQuizzes = true
    })

    .addCase(getQuiz.fulfilled, (state, action) => {
      state.quiz = action.payload

      state.loading.getQuiz = false
      state.error.getQuiz = false
    })
    .addCase(getQuiz.pending, (state) => {
      state.loading.getQuiz = true
      state.error.getQuiz = false
    })
    .addCase(getQuiz.rejected, (state) => {
      state.loading.getQuiz = false
      state.error.getQuiz = true
    })

    .addCase(addQuiz.fulfilled, (state) => {
      state.loading.addQuiz = false
      state.error.addQuiz = null
      state.success.addQuiz = true
    })
    .addCase(addQuiz.pending, (state) => {
      state.loading.addQuiz = true
      state.error.addQuiz = null
      state.success.addQuiz = false
    })
    .addCase(addQuiz.rejected, (state, action) => {
      state.loading.addQuiz = false
      state.error.addQuiz = action.error?.message || null
      state.success.addQuiz = false
    })

    .addCase(editQuiz.fulfilled, (state) => {
      state.loading.editQuiz = false
      state.error.editQuiz = null
      state.success.editQuiz = true
    })
    .addCase(editQuiz.pending, (state) => {
      state.loading.editQuiz = true
      state.error.editQuiz = null
      state.success.editQuiz = false
    })
    .addCase(editQuiz.rejected, (state, action) => {
      state.loading.editQuiz = false
      state.error.editQuiz = action.error?.message || null
      state.success.editQuiz = false
    })

    .addCase(resetQuiz, (state) => {
      state.quiz = null
      state.loading.getQuiz = false
      state.error.getQuiz = false
    })

    .addCase(resetAddQuizSuccess, (state) => {
      state.success.addQuiz = false
    })

    .addCase(resetEditQuizSuccess, (state) => {
      state.success.editQuiz = false
    })

    .addDefaultCase((state) => state)
})

const quizState = (state) => state.quiz

export const selectQuizzes = createSelector(quizState, ({ quizzes }) => quizzes)

export const selectQuizzesPagination = createSelector(
  quizState,
  ({ quizzes, quizzesTotal, quizzesPageSize, quizzesPage }) => ({
    quizzes,
    quizzesTotal,
    quizzesPageSize,
    quizzesPage,
  })
)

export const selectQuiz = createSelector(quizState, ({ quiz }) => quiz)

export const selectLoadingAddQuiz = createSelector(quizState, ({ loading: { addQuiz } }) => addQuiz)

export const selectErrorAddQuiz = createSelector(quizState, ({ error: { addQuiz } }) => addQuiz)

export const selectSuccessAddQuiz = createSelector(quizState, ({ success: { addQuiz } }) => addQuiz)

export const selectLoadingEditQuiz = createSelector(
  quizState,
  ({ loading: { editQuiz } }) => editQuiz
)

export const selectErrorEditQuiz = createSelector(quizState, ({ error: { editQuiz } }) => editQuiz)

export const selectSuccessEditQuiz = createSelector(
  quizState,
  ({ success: { editQuiz } }) => editQuiz
)

export const selectLoadingQuizzes = createSelector(
  quizState,
  ({ loading: { getQuizzes } }) => getQuizzes
)

export default quizReducer
